import { render } from "./GridStariPosturi.vue?vue&type=template&id=7206340c&ts=true"
import script from "./GridStariPosturi.vue?vue&type=script&lang=ts"
export * from "./GridStariPosturi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__